import { render, staticRenderFns } from "./BrandPartsTypeEditLayer.vue?vue&type=template&id=86ac8f32&scoped=true&"
import script from "./BrandPartsTypeEditLayer.vue?vue&type=script&lang=js&"
export * from "./BrandPartsTypeEditLayer.vue?vue&type=script&lang=js&"
import style0 from "./BrandPartsTypeEditLayer.vue?vue&type=style&index=0&id=86ac8f32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ac8f32",
  null
  
)

export default component.exports